/**
 * Theme Hook
 *
 * Manages light/dark mode with localStorage persistence.
 * Only manual selection - no system auto-detection.
 */

import { useEffect, useState } from 'react'

type Theme = 'light' | 'dark'

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    if (typeof window === 'undefined') return 'light'
    return (localStorage.getItem('theme') as Theme) || 'light'
  })

  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light')
  }

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
    // Color de la barra del navegador en el celular, igual al fondo del tema
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', theme === 'dark' ? '#030712' : '#fafafa')
  }, [theme])

  const isDark = theme === 'dark'

  return { theme, setTheme, toggleTheme, isDark }
}
